import axios from 'axios';
require('dotenv/config');

const { protocol, hostname, } = window.location;
const port = 4444;

/**
 * Em producao o TLS e terminado no proxy reverso, que pode expor a API sob o
 * mesmo dominio do dashboard (ex.: REACT_APP_API_URL="/api/") ou em outra
 * origem. Sem a variavel mantem o comportamento antigo: mesmo host do
 * dashboard na porta 4444, herdando o protocolo da pagina.
 */
const baseURL = process.env.REACT_APP_API_URL || `${protocol}//${hostname}:${port}/`;

const api = axios.create({
  baseURL,
});

/**
 * Users
 */

export function listUsers() {
  return api.get('/users');
}

/**
 * @param {string} name - user name
 * @param {string} email - user email
 * @param {string} password - user password
 * @param {string} avatar - user avatar
 * @param {boolean} admin - whether the user is admin or not
 */
export function createUser(name, email, password, avatar, admin) {
  return api.post('/singup', {
    name,
    email,
    avatar,
    password,
    admin,
  });
}

/**
 * @param {string} email - user email
 */
export function regenerateUserQrCode(email) {
  return api.post('/qrcode', {
    email,
  });
}

export function deleteUser(userId) {
  return api.delete(`/users/${userId}`);
}

/**
 * Companies
 */

/**
 * @param {boolean | undefined} isActive - only list companies with the given isActive state
 */
export async function listCompanies(isActive) {
  return api.get('/empresas', {
    params: {
      ativa: undefined != isActive ? isActive ? 1 : 0 : isActive,
    },
  });
}

/**
 * @param {string} name - company name
 * @param {ContractType} contrato - the type of contract of the company
 * @param {string} pacote - amount of hours contracted by the company
 * @param {boolean} isActive - whether the company is active or not
 * @param {number} success
 */
export async function createCompany(name, contrato, pacote, isActive, success) {
  return api.post('/criar/empresas', {
    name,
    sucess: success,
    ativa: isActive ? 1 : 0,
    contrato,
    pacote_horas: pacote,
  });
}

/**
 * @param {string} companyId
 * @param {boolean} isActive
 */
export function changeCompanyActiveState(companyId, isActive) {
  return api.post('/empresas/archive', {
    id: companyId,
    ativa: isActive ? 1 : 0,
  });
}

/**
 * Servers
 */

/**
 * @param {string} companyId
 * @param {string} serverName
 */
export async function createCompanyServer(companyId, serverName) {
  return api.post('/criar/host', {
    host: serverName,
    idEmpresa: companyId,
  });
}

/**
 * @param {string} companyId
 */
export async function listCompanyServers(companyId) {
  return api.get('/mostra/empresas', {
    params: {
      id: companyId,
    },
  });
}

/**
 * @param {string} companyId
 * @param {string} serverId
 */
export async function deleteCompanyServer(companyId, serverId) {
  return api.delete(`/companies/${companyId}/hosts/${serverId}`);
}

/**
 * @param {string} companyId
 * @param {string} serverId
 * @param {string} name - updated server name
 */
export async function updateCompanyServer(companyId, serverId, name) {
  return api.put(`/companies/${companyId}/hosts/${serverId}`, {
    name,
  });
}

/**
 * Tickets
 */

/**
 * @param {string | undefined} startDate - start date string (YYY-MM-DD) or undefined. If provided,
 * endDate must be a valid date string
 * @param {string | undefined} endDate - end date string (YYY-MM-DD) or undefined. If provided,
 * startDate must be a valid date string
 */
export async function listTickets(startDate, endDate) {
  return api.get('chamados', {
    params: {
      startDate,
      endDate,
    },
  });
}

export async function getTicketYearlySummary() {
  return api.get('/static/year');
}

export async function getTicketMonthlySummary() {
  return api.get('/static/month');
}

/**
 * Ticket types
 */

export async function listTicketTypes() {
  return api.get('/ticket-types');
}

/**
 * @param {string} ticketType - ticket type name
 */
export async function createTicketType(ticketType) {
  return api.post('/ticket-types', {
    type: ticketType,
  });
}

/**
 * @param {number} ticketTypeId
 * @param {string} type
 */
export async function updateTicketType(ticketTypeId, type) {
  return api.put(`/ticket-types/${ticketTypeId}`, {
    type,
  });
}

/**
 * @param {number} ticketTypeId
 */
export async function deleteTicketType(ticketTypeId) {
  return api.delete(`/ticket-types/${ticketTypeId}`);
}

/**
 * Backup alerts
 */

export async function listBackupAlerts() {
  return api.get('/showAlerts');
}

export async function sendBackupAlertEmailReport() {
  return api.get('/backup_Alert');
}

/**
 * Monitoring
 */

export async function listMonitoring() {
  return api.get('/monitoramento');
}

/**
 * Scripts
 */

export async function listHostScripts(hostId) {
  return api.post('/scripts', {
    id: hostId,
  });
}

export async function createHostScript(hostId, scriptName) {
  return api.post('/criar/script', {
    idHost: hostId,
    name: scriptName,
  });
}

export async function deleteHostScript(companyId, hostId, scriptId) {
  return api.delete(`/companies/${companyId}/hosts/${hostId}/scripts/${scriptId}`);
}


export default api;
